import { render } from "./SecuritySettingsPage.vue?vue&type=template&id=d8689cc2&scoped=true"
import script from "./SecuritySettingsPage.vue?vue&type=script&lang=js"
export * from "./SecuritySettingsPage.vue?vue&type=script&lang=js"

import "./SecuritySettingsPage.vue?vue&type=style&index=0&id=d8689cc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8689cc2"]])

export default __exports__